module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[83]570.7028bac.woff2";